import { CarRentalState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import { CarExtra } from "../interfaces/carExtra";
import { AvailableCarRentals, CarRental } from "../interfaces/carRental";
import { AvailableCarExtra } from "../interfaces/availableCarExtra";

export default {
    getAvailableCarRentals(state: CarRentalState): AvailableCarRentals | []{
        return state.availableCarRentals;
    },
    getAvailableCarExtras(state: CarRentalState): AvailableCarExtra[]{
        return state.availableExtras;
    },
    getCarExtras(state: CarRentalState): CarExtra[]{
        return state.carExtras;
    },
    getChosenCarRentals(state: CarRentalState): CarRental[] {
        return state.carRentals;
    },
    hasCarRentals(state): boolean {
        return Object.values(state.carRentals).length > 0;
    },
    hasCarExtras(state): boolean {
        return state.availableExtras.length > 0;
    }
} as GetterTree<CarRentalState, IStore>
